import { render } from "./HzbaDeleteDuplicateItem.vue?vue&type=template&id=8ed1d316&scoped=true&ts=true"
import script from "./HzbaDeleteDuplicateItem.vue?vue&type=script&lang=ts"
export * from "./HzbaDeleteDuplicateItem.vue?vue&type=script&lang=ts"

import "./HzbaDeleteDuplicateItem.vue?vue&type=style&index=0&id=8ed1d316&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ed1d316"]])

export default __exports__